import React from "react";
import { Card, Text, Badge, Group, Avatar, Stack, Title } from "@mantine/core";
import { CheckIcon } from "@mantine/core";
import { IconProgress } from "@tabler/icons-react";

export default function Note() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        gap: "15px",
        marginTop: "10px",
      }}
    >
      <Card
        shadow="sm"
        radius="md"
        withBorder
        style={{ flex: 1, minWidth: "200px" }}
      >
        <Group position="apart" mb="md">
          <Title color="red" order={4}>
            Internet Not Working
          </Title>
          <Text>
            {" "}
            Vivamus blandit, odio eget tristique volutpat, eros lectus auctor
            lorem, vitae sagittis sapien mauris interdum ex. Donec eu eleifend
            massa. Donec viverra, ex ut euismod hendrerit, nunc nisi cursus est,
            nec scelerisque lorem erat vel nunc. Duis non urna ornare, commodo
            felis ac, fringilla tortor. Nulla dui libero, dignissim et eros id,
            elementum rutrum risus
            <br />
            Vivamus blandit, odio eget tristique volutpat, eros lectus auctor
            lorem, vitae sagittis sapien mauris interdum ex. Donec eu eleifend
            massa. Donec viverra, ex ut euismod hendrerit, nunc nisi cursus est,
            nec scelerisque lorem erat vel nunc. Duis non urna ornare, commodo
            felis ac, fringilla tortor. Nulla dui libero, dignissim et eros id,
            elementum rutrum risus
          </Text>
        </Group>
      </Card>
    </div>
  );
}
